import { motion } from "framer-motion";
import AnimatedSection from "./AnimatedSection";

const audiences = [
  "Busy Parents",
  "Remote Professionals",
  "The Elderly",
  "Local Students",
  "Newcomers",
];

function TargetAudience() {
  return (
    <section className="py-24 px-8 bg-surface-container-low text-center scroll-mt-20" id="audience">
      <div className="max-w-4xl mx-auto space-y-12">
        <AnimatedSection>
          <h2 className="font-headline text-4xl md:text-5xl font-extrabold tracking-tight">
            Built for everyday life.
          </h2>
        </AnimatedSection>

        <div className="flex flex-wrap justify-center gap-4">
          {audiences.map((audience, i) => (
            <motion.span
              key={audience}
              className="px-6 py-3 bg-white rounded-full font-bold shadow-sm"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.1 }}
            >
              {audience}
            </motion.span>
          ))}
        </div>

        <AnimatedSection delay={0.4}>
          <p className="text-xl text-on-surface-variant italic">
            "SOLID isn't just an app; it's the glue that holds a modern neighborhood together."
          </p>
        </AnimatedSection>
      </div>
    </section>
  );
}

export default TargetAudience;
